<template>
  <span class="mc-liveview-legend">
    <i class="mc-fa icon-outline_info" id="legend"></i>

    <b-popover
      target="legend"
      triggers="click"
      :show.sync="popoverShow"
      placement="rightmiddle"
      container="my-container"
      ref="popover"
    >
      <template #title>
        {{ $t('global.object.info') }}
        <i
          @click="onClose"
          class="mc-popover-close mc-fa icon-outline_close"
          aria-hidden="true"
        ></i>
      </template>

      <div class="mc-popover-content mc-popover-content--legend">
        <ul>
          <li>
            <p>{{ $t('global.object.fleetStatus') }}</p>
            <div>
              <label
                ><img src="@/assets/images/caricon/car-green.svg" alt /><span>{{ $t('global.filter.running') }}</span></label
              >
              <label
                ><img src="@/assets/images/caricon/car-yellow.svg" alt /><span>{{ $t('global.filter.idle') }}</span></label
              >
              <label
                ><img src="@/assets/images/caricon/car-red.svg" alt /><span>{{ $t('global.filter.parking') }}</span></label
              >
              <label
                ><img src="@/assets/images/caricon/car-grey.svg" alt /><span>{{ $t('global.filter.offline') }}</span></label
              >
            </div>
          </li>
        </ul>
      </div>
    </b-popover>
  </span>
</template>

<script>
export default {
  name: 'LGSelectOptions',
  data() {
    return {
      popoverShow: false,
    }
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },
  },
}
</script>
